<template>
    <MonthlyCalender :month="july"/>
</template>
<script>
import MonthlyCalender from "./../components/MonthlyCalender";
export default {
    name: 'July',
    data(){
        return {
            july: 'July'
        }
    },
    components: {
        MonthlyCalender
    }
}
</script>